export async function stickerImageUrl(sticker) {
    if(typeof sticker === 'string'){
        return Promise.resolve(sticker);
    }

    if(sticker.imagePath){
        const cdnUrl = process.env.VUE_APP_AZURE_CDN_URL;
        const container = process.env.VUE_APP_AZURE_CONTAINER;
        return Promise.resolve(`${cdnUrl}/${container}/${sticker.imagePath}`);
    }

    return Promise.resolve(sticker.id);
};